// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2ZpuX","buttons":"RemoveExpirationActionButtons_buttons__kxku8"};